<template>
  <div class = "bottom-margin">
    <v-row v-for="segment in segments" :key="segment.sys.id">
      <segment
        v-if="
        segment.sys.contentType.sys.id.toString() === 'ageInSegment'
        "
        :fields="segment.fields"
        :sysId="segment.sys.id"
        :firstOne="(segment===segments[0]) ? true: false"
        :lastOne="(segment===segments[segments.length - 1]) ? true: false"
      />
    </v-row>
  </div>
</template>

<script>

import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import Segment from './segment'

export default {
  name: 'AgeInGraph',
  components: {
    Segment
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      segments: []
    }
  },
  async created () {
    const { items, includes } = await queryCTF(
      `&include=2&content_type=ageInGraph&select.fields&sys.id=${this.sysId}`
    )
    if (items && includes) {
      const group = items[0]
      const entries = includes.Entry.filter((x) =>
        group.fields.ageInSegments.find((t) => t.sys.id === x.sys.id)
      )
      const sortedEntries = await sortCTFEntries(
        group.fields.ageInSegments,
        entries
      )
      this.segments = sortedEntries
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.background {
  position: relative;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}

.bottom-margin{
  margin-bottom:30px;
}

.row{
  margin-right: 0;
  margin-left:0;
}
</style>
